import { createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "req-renew-ben-cards-plan" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["CommonModal"], {
    ref: "commonModal",
    "is-full-screen": true,
    "can-minimize": true,
    "minimized-data": {
      type: $setup.MinimizedType.BENEFITS_CARD,
    },
    onOnCloseByButton: _cache[2] || (_cache[2] = ($event: any) => ($setup.reqRenewBenCardsPlanStore.$reset()))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[3] || (_cache[3] = _createElementVNode("p", { class: "main-title" }, "Renovação de plano de cartão", -1 /* HOISTED */)),
        _cache[4] || (_cache[4] = _createElementVNode("div", { style: {"height":"var(--semantic-size-semantic-spacing-stack-600, 48px)"} }, null, -1 /* HOISTED */)),
        _createCommentVNode(" INITIAL SCREEN "),
        _createVNode($setup["PatchBenCardsPlanScreen"], {
          "show-screen": $setup.reqRenewBenCardsPlanStore.currentScreen == $setup.ReqBenCardsRenewScreens.INITIAL,
          onClose: _cache[0] || (_cache[0] = ($event: any) => ($setup.commonModal?.close()))
        }, null, 8 /* PROPS */, ["show-screen"]),
        _createCommentVNode(" CONFIRM VALUE SCREEN "),
        _createVNode($setup["ConfirmValueScreen"], {
          "show-screen": $setup.reqRenewBenCardsPlanStore.currentScreen == $setup.ReqBenCardsRenewScreens.VALUE_CONFIRMATION
        }, null, 8 /* PROPS */, ["show-screen"]),
        _createCommentVNode(" PAYMENT SCREEN "),
        _createVNode($setup["PaymentScreen"], {
          "show-screen": $setup.reqRenewBenCardsPlanStore.currentScreen == $setup.ReqBenCardsRenewScreens.PAYMENT,
          onClose: _cache[1] || (_cache[1] = ($event: any) => ($setup.commonModal?.close()))
        }, null, 8 /* PROPS */, ["show-screen"])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["minimized-data"]))
}